/** @fileoverview Renders the tenant switcher. */

import { Select, SelectContent, SelectItem, SelectTrigger } from './ui/select';
import type { Tenant, User } from '../types/identity';

type Props = {
  user?: User;
  tenants: Tenant[];
  selectedTenantId: string;
  onSelect: (tenantId: string) => void;
};

/** Shows the signed-in user's available tenants. */
export default function TenantSelector({ user, tenants, selectedTenantId, onSelect }: Props) {
  if (!user) return null;

  const selectedTenant = tenants.find((tenant) => tenant.tenant_id === selectedTenantId);

  return (
    <Select
      value={selectedTenantId}
      onValueChange={(value) => {
        if (value) onSelect(value);
      }}
    >
      <SelectTrigger
        className="h-9 w-48 rounded-md border-app-border-strong bg-app-surface-card px-3 text-sm font-normal text-app-nav"
        aria-label="Tenant"
      >
        <span className="min-w-0 flex-1 truncate text-left">
          {selectedTenant?.name || 'Choose workspace'}
        </span>
      </SelectTrigger>
      <SelectContent align="center" className="min-w-48">
        {tenants.map((tenant) => (
          <SelectItem key={tenant.tenant_id} value={tenant.tenant_id}>
            {tenant.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
